import { OnboardingDetailsRole, OnboardingDetailsType } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { GetLoanDetailActionsByRoleProps } from '@/components/widgets/LoanDetailActions/types/GetLoanDetailActionsByRoleProps';
import { LoanDetailAction } from '@/components/widgets/LoanDetailActions/types/LoanDetailAction';
import { APP_ROLES } from '@/config/config';

export const getAddCoBorrowerRelatedActions = ({ toggleActionDialog, loan, role }: GetLoanDetailActionsByRoleProps) => {
  const loanIsOfTypeBusiness = loan.onboardingDetails.some(
    (details) => details.type === OnboardingDetailsType.BUSINESS,
  );

  const loanHasParticipants = () =>
    loan.onboardingDetails.some((detail) => detail.role !== OnboardingDetailsRole.BORROWER);

  if (
    !(
      role === APP_ROLES.ADMIN ||
      role === APP_ROLES.SUPER_ADMIN ||
      role === APP_ROLES.LENDER ||
      role === APP_ROLES.MERCHANT ||
      role === APP_ROLES.CHANNEL ||
      role === APP_ROLES.AGENT ||
      role === APP_ROLES.CPC_BACK_OFFICE
    )
  )
    return [];

  return [
    {
      display: loanIsOfTypeBusiness ? <Text tId={'ADD_GUARANTOR_TO_LOAN'} /> : <Text tId={'ADD_PARTICIPANT_TO_LOAN'} />,
      onClick: () => toggleActionDialog(LoanDetailAction.ADD_PARTICIPANT_TO_LOAN),
      iconName: 'group_add',
      // disabled: loanHasAllParticipants(),
    },
    {
      display: loanIsOfTypeBusiness ? (
        <Text tId={'REMOVE_GUARANTOR_FROM_LOAN'} />
      ) : (
        <Text tId={'REMOVE_PARTICIPANT_FROM_LOAN'} />
      ),
      onClick: () => toggleActionDialog(LoanDetailAction.REMOVE_PARTICIPANT_FROM_LOAN),
      iconName: 'group_remove',
      disabled: !loanHasParticipants(),
    },
  ];
};
